import { render, staticRenderFns } from "./RefreshResults.vue?vue&type=template&id=795c8953&scoped=true&"
import script from "./RefreshResults.vue?vue&type=script&lang=js&"
export * from "./RefreshResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795c8953",
  null
  
)

export default component.exports